<ng-container *ngIf="(loadingRoutes$ | async) || (loading$ | async)">
    <div [class]="classDefault">
        <ng-container *ngIf="customLoadingIndicator; else spinner">
            <ng-container *ngTemplateOutlet="customLoadingIndicator" />
        </ng-container>
        <ng-template #spinner>
            <mat-spinner />
        </ng-template>
    </div>
</ng-container>
